import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { getCheckedOptionFromView, PUBLIC } from '../../getCheckedOptionFromView';
import { useBETCanCurrentUserMakePublicView } from '../../useBETCanCurrentUserMakePublicView';
import { jsx as _jsx } from "react/jsx-runtime";
export const PublicRadioOption = ({
  viewUpdates,
  setViewUpdates
}) => {
  const isChecked = getCheckedOptionFromView(viewUpdates) === PUBLIC;
  const {
    data: canMakeViewsPublic,
    loading,
    error
  } = useBETCanCurrentUserMakePublicView();
  const handleChange = useCallback(() => {
    setViewUpdates({
      private: false,
      teamId: undefined
    });
  }, [setViewUpdates]);
  if (loading) {
    return /*#__PURE__*/_jsx(RadioInput, {
      disabled: true,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "viewsManagement.modals.manageSharing.loading"
      })
    });
  }
  if (error) {
    return /*#__PURE__*/_jsx(RadioInput, {
      disabled: true,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "viewsManagement.modals.manageSharing.error"
      })
    });
  }
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: canMakeViewsPublic,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "viewsManagement.modals.manageSharing.shareViewEveryoneDisabledTooltip"
    }),
    children: /*#__PURE__*/_jsx(RadioInput, {
      "data-test-id": `view-sharing-everyone-checked=${isChecked}`,
      disabled: !canMakeViewsPublic,
      checked: isChecked,
      onChange: handleChange,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "viewsManagement.modals.manageSharing.everyone"
      })
    })
  });
};